import { Auth } from "aws-amplify"


export const apiconfig = {endpoints:[
    {
        name: 'ceresapi',
        endpoint: ' https://vcldcshdp6.execute-api.us-east-1.amazonaws.com/Prod',
        custom_header: async () => {
            return { Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
        },
    },
]}

const awsmobile = {
   "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:c398f9b7-adb7-4728-957e-89a02bd00b75",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_zYJtFzgH4",
    "aws_user_pools_web_client_id": "6k4g8mr1fcm1rl5ebdf9btt061",
    "oauth": {},
    // iosku
    "aws_appsync_graphqlEndpoint": "https://kxqsviv2efeytmd6gld3bahjeq.appsync-api.us-east-1.amazonaws.com/graphql",
    // iosku-test
    // "aws_appsync_graphqlEndpoint": "https://rr2e5i3sqbgjhntlpnkc55geie.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "file-locker",
    "aws_user_files_s3_bucket_region": "us-east-1"
};

export default awsmobile;
